import { Animation } from "@nocios/presentation-kit";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 9;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const DATA_IMAGES = [
    {
      image: `${baseImageUrl}phone.png`,
      effect: "animate-phone",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
  ];

  const times = [600, 600, 600, 600, 500, 600];

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "AI-Powered\nSelf-Healing Networks",
    description: `Enhance reliability with intelligent automation\nthat resolves issues before they impact users.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Automated Issue Resolution: AI reroutes traffic\nand repairs broken connections in real time.</li>\n<li>Minimal Manual Intervention: The system\ndetects and resolves network failures\nautonomously.</li>\n<li>Optimized Network Performance: Ensures\nseamless connectivity with proactive AI-driven\nmaintenance.</li></ul>`}
      />
    ),
    rightSideComponent: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
